// profileInformationThunks.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiUrl } from '../../../Network/ApiUrl';
import { put } from '../../../Network/ApiService';
import { RootState } from '../..';
import { fetchProviderProfileData } from '../getProfileData/providerProfileThunk';

interface StoreProviderProfileDataArgs {
  authToken: string;
  data: any; // Adjust the type of data to match your data structure
  userId: string;
}

// Define the return type for the Thunk action
interface ProviderDataResponse {
  status: number;
  message: string;
}

// Create the Thunk action
export const storeProviderProfileData = createAsyncThunk<ProviderDataResponse, StoreProviderProfileDataArgs, { state: RootState }>(
  'profile/storeProviderProfileData',
  async ({ authToken, data, userId }, { dispatch }) => {
    console.log("🚀 ~ userId:", userId)
    try {
      const API_URL = `${ApiUrl.user_profile.save_provider_profile}?userId=${userId}`;
      const successResponse = await put(API_URL, data, authToken);
      // const successResponse = await post(ApiUrl.user_profile.get_provider_profile, authToken, data);
      if (successResponse.status === 200) {
        dispatch(fetchProviderProfileData({ userId, authToken }));
        return { status: 200, message: 'Data saved successfully' };
      } else {
        return { status: successResponse.status, message: 'Error in saving Data' };
      }
    } catch (error) {
      return { status: 500, message: 'Internal Server Error' };
    }
  }
);
